import { render, staticRenderFns } from "./billOil.vue?vue&type=template&id=2b1b652a&scoped=true&"
import script from "./billOil.vue?vue&type=script&lang=js&"
export * from "./billOil.vue?vue&type=script&lang=js&"
import style0 from "./billOil.vue?vue&type=style&index=0&id=2b1b652a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b652a",
  null
  
)

export default component.exports